import { render, staticRenderFns } from "./StockUp.vue?vue&type=template&id=19f91c7a&scoped=true"
import script from "./StockUp.vue?vue&type=script&lang=js"
export * from "./StockUp.vue?vue&type=script&lang=js"
import style0 from "./StockUp.vue?vue&type=style&index=0&id=19f91c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f91c7a",
  null
  
)

export default component.exports